export const luxury = [
  {
    id: 1,
    name: "Mercedes E-Class",
    image: "/images/gallery/luxury/mercedes-eclass.png",

    gallery: [
      "/images/gallery/luxury/mercedes-eclass.png",
      "/images/gallery/luxury/mercedes-eclass-interior.jpg",
      "/images/gallery/luxury/mercedes-eclass-back.jpg"
    ],

    body: "Luxury Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "1991 cc / 1950 cc",
    transmission: "Automatic",
    fuel: "Petrol / Diesel",
    ac: "AC"
  },

  {
    id: 2,
    name: "BMW 5 Series",
    image: "/images/gallery/luxury/bmw-5series.png",

    gallery: [
      "/images/gallery/luxury/bmw-5series.png",
      "/images/gallery/luxury/bmw-5series-interior.jpg",
      "/images/gallery/luxury/bmw-5series-back.jpg"
    ],

    body: "Luxury Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "1998 cc",
    transmission: "Automatic",
    fuel: "Petrol / Diesel",
    ac: "AC"
  },

  {
    id: 3,
    name: "Audi A5",
    image: "/images/gallery/luxury/audi-a5.png",

    gallery: [
      "/images/gallery/luxury/audi-a5.png",
      "/images/gallery/luxury/audi-a5-interior.jpg",
      "/images/gallery/luxury/audi-a5-back.jpg"
    ],

    body: "Luxury Sedan / Sportback",
    seats: "4 + 1",
    doors: "4",
    engine: "1984 cc",
    transmission: "Automatic",
    fuel: "Petrol",
    ac: "AC"
  },

  {
    id: 4,
    name: "Jaguar XJ",
    image: "/images/gallery/luxury/jaguar-xj.png",

    gallery: [
      "/images/gallery/luxury/jaguar-xj.png",
      "/images/gallery/luxury/jaguar-xj-interior.jpg",
      "/images/gallery/luxury/jaguar-xj-back.jpg"
    ],

    body: "Luxury Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "2995 cc / 2993 cc",
    transmission: "Automatic",
    fuel: "Petrol / Diesel",
    ac: "AC"
  }
];
